
import { FETCH_GEO_PAYEMENT_FAILURE, FETCH_GEO_PAYEMENT_REMOVE, FETCH_GEO_PAYEMENT_REQUEST, FETCH_GEO_PAYEMENT_SUCCESS } from "../types/index";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

const geopayementReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_GEO_PAYEMENT_REQUEST:
      return { ...state, loading: true, error: null ,  };
    case FETCH_GEO_PAYEMENT_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case FETCH_GEO_PAYEMENT_FAILURE:
      return { ...state, loading: false, error: action.error , data:[]};
    case FETCH_GEO_PAYEMENT_REMOVE:
      return { ...state, loading: false, data:[] , error:null };
    default:
      return state;
  }
};

export default geopayementReducer;
